import { fetchAuthSession } from "aws-amplify/auth";

const FEEDBACK_API_URL = import.meta.env.VITE_FEEDBACK_API_URL;

async function getAuthHeaders(): Promise<Record<string, string>> {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: token } : {}),
  };
}

export const feedbackApi = {
  async submit(data: {
    type: "bug" | "feature";
    title: string;
    description: string;
    priority: string;
    organizationId: string;
    submittedBy: string;
    submittedByEmail: string;
    diagnostics?: unknown;
  }) {
    const headers = await getAuthHeaders();
    const res = await fetch(`${FEEDBACK_API_URL}/tickets`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: res.statusText }));
      throw new Error(err.error || "Failed to submit");
    }
    return res.json();
  },

  async list(organizationId: string) {
    const headers = await getAuthHeaders();
    const res = await fetch(`${FEEDBACK_API_URL}/tickets?organizationId=${organizationId}`, {
      headers,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: res.statusText }));
      throw new Error(err.error || "Failed to load tickets");
    }
    return res.json();
  },
};
